import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DirectivesModule } from '@app/modules/directives/directives.module';
import { InputsModule } from '@app/modules/inputs';
import { ModalsModule } from '@app/modules/modals/modals.module';
import { PipesModule } from '@app/modules/pipes/pipes.module';
import { SurfaceTierIconButtonComponent } from '@app/modules/surface/components/surface-tier-icon-button/surface-tier-icon-button.component';
import { SurfaceUpgradePopoverComponent } from '@app/modules/surface/components/surface-upgrade-popover/surface-upgrade-popover.component';
import { SurfaceAlertComponent } from '@app/modules/surface/surface-alert/surface-alert.component';
import { SurfaceSkuLimitAlertComponent } from '@app/modules/surface/surface-sku-limit-alert/surface-sku-limit-alert.component';
import { SpinnerComponent } from '@app/standalone-components/spinner/spinner.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbAlert, NgbCollapseModule, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { AlertModule } from '../alerts/alert.module';

@NgModule({
    declarations: [
        SurfaceAlertComponent,
        SurfaceSkuLimitAlertComponent,
        SurfaceTierIconButtonComponent,
        SurfaceUpgradePopoverComponent
    ],
    exports: [
        SurfaceAlertComponent,
        SurfaceSkuLimitAlertComponent,
        SurfaceTierIconButtonComponent,
        SurfaceUpgradePopoverComponent
    ],
    imports: [
        AlertModule,
        CommonModule,
        DirectivesModule,
        FontAwesomeModule,
        FormsModule,
        InputsModule,
        ModalsModule,
        NgbAlert,
        NgbCollapseModule,
        NgbPopoverModule,
        PipesModule,
        ReactiveFormsModule,
        SpinnerComponent
    ]
})
export class SurfaceModule { }
